import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Returns relative time from provided ISO time string, or null if invalid.
 * Uses dayjs relativeTime (English locale, matching prior usage).
 */
export const getRelativeTime = (ISOTimestamp: string): string | null => {
  if (!ISOTimestamp?.trim()) {
    return null;
  }
  const d = dayjs(ISOTimestamp);
  if (!d.isValid()) {
    return null;
  }
  const now = dayjs();
  if (Math.round(d.diff(now) / 1000) === 0) {
    return 'now';
  }
  return d.from(now);
};
